<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main treeMain">
      <div class="topMain" style="margin-bottom: 15px;">
        <div slot="header" class="clearfix">
          <span>设备分类</span>
          <el-button style="float: right;" type="primary" v-if="!empty" @click="empty=true">创建分类</el-button>
        </div>
      </div>
      <div class="coreMain">
        <el-row :gutter="24">
          <el-col :span="6" style="position:relative;">
            <label for="">搜索分类名称</label>
            <el-input class="treeFilter" placeholder="输入关键字进行过滤" v-model="filterText">
            </el-input>

            <el-tree class="filter-tree" accordion :data="treeList" :default-expanded-keys="expansion"
              :props="defaultProps" node-key="value" :highlight-current="true" @node-click="changeTree"
              :filter-node-method="filterNode" ref="treeData">
            </el-tree>
          </el-col>
          <el-col :span="18" class="rightInfo">
            <div v-if="!empty">
              <label style="margin-bottom:8px">分类信息</label>
              <el-button class="addCreationBtn"
                style="font-size:12px;padding:4px 15px;float: right;margin-left:10px;margin-top:0;" plain
                @click="editBtn(info.id)">编辑</el-button>
              <el-button class="quitCreationBtn" plain @click="delBtn(info.id)">删除</el-button>

              <div class="info">
                <el-row :span="24">
                  <el-col :span="12" class="baseInfo">
                    <label>父类型</label> <br />
                    <span>{{info.parentName!=null?info.parentName:'无'}}</span>
                  </el-col>
                  <el-col :span="12" class="baseInfo">
                    <label>分类名称</label> <br />
                    <span>{{info.name!=null?info.name:'---'}}</span>
                  </el-col>
                </el-row>
                <el-row :span="24">
                  <el-col :span="12" class="baseInfo">
                    <label>创建人</label> <br />
                    <span>{{info.creator!=null?info.creator:'---'}}</span>
                  </el-col>
                  <el-col :span="12" class="baseInfo">
                    <label>创建时间</label> <br />
                    <span>{{info.createDate!=null ? changeDate(info.createDate):'---'}}</span>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div v-if="empty">
              <label>创建分类</label>
              <el-button class="quitCreationBtn" plain @click="signOut">退出创建</el-button>
              <div class="info">
                <form action="" :data='addForm'>
                  <el-row :span="24">
                    <el-col :span="10" class="baseInfo">
                      <label>父级名称</label> <br />
                      <el-cascader style="width: 45%;" placeholder="请选择" :options="deviceClassList" v-model="parentId"
                        clearable filterable change-on-select></el-cascader>
                    </el-col>
                    <el-col :span="10" class="baseInfo">
                      <label>名称</label> <br />
                      <el-input v-model="addForm.name" placeholder="请输入" maxlength="100"></el-input>
                    </el-col>
                    <el-col :span="4" class="baseInfo" style="text-align: center;">
                      <label>&nbsp;</label> <br />
                      <el-button class="addCreationBtn" type="primary" plain @click="addBtn()">添加</el-button>
                    </el-col>
                  </el-row>
                </form>
              </div>
            </div>
          </el-col>

        </el-row>
      </div>
    </div>
    <!-- 编辑 -->
    <el-dialog title="编辑分类信息" :visible.sync="dialogFormVisible">
      <el-form :model="editForm">
        <el-form-item label="分类名称">
          <el-input v-model="editForm.name" autocomplete="off" maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs";
  export default {
    watch: {
      //过滤左侧tree的值
      filterText(val) {
        this.$refs.treeData.filter(val);
      },

    },
    data() {
      return {
        empty: false, //控制数据为空展示创建分类页
        dialogFormVisible: false, //编辑窗口
        filterText: '', //过滤节点
        treeList: [], //树形数据
        expansion: [], //默认展开项
        deviceClassList: [], //父名称下拉数据
        parentId: [], //父名称数组
        info: {}, //右侧详情信息
        editForm: {}, //更改当前设备名称
        //tree树状的配置key
        defaultProps: {
          children: 'children',
          label: 'label',
          id: 'id'
        },
        addForm: {}, //新建分类数据
      };
    },
    created() {

    },
    methods: {

      //格式化时间
      changeDate(time) {
        return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      },

      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //获取设备分类树形数据
      getTree() {
        API.platformDevCategoryDevCategoryList().then(res => {
          let _this = this
          if (res.code == 1) {

            if (res.data.devCategoryTreeList.length === 0) {
              return;
            }


            this.treeList = res.data.devCategoryTreeList
            // 异步处理节点默认项
            setTimeout(() => {
              _this.$refs.treeData.setCurrentKey(_this.treeList[0].value); //默认选择第一个节点的父节点
              _this.expansion.push(_this.treeList[0].value) //默认展开第一个节点
            }, 50)
            //默认差第一个父节点的详情
            this.getDetalis(_this.treeList[0].value)
            if (this.treeList.length == 0) {
              this.empty = true
            } else {
              this.empty = false
            }
            //获取父名称数据
            API.platformDevCategoryDevCategoryList().then(res => {
              if (res.code == 1) {
                this.deviceClassList = res.data.devCategoryTreeList
              }
            })
          }
        })
      },
      //选择节点刷新右侧详情
      changeTree(data) { //data是节点的数据
        this.getDetalis(data.value)
      },
      signOut() { //退出创建
        this.empty = false;
        this.addForm.name = "";
        this.parentId = [];
      },

      //查看设备分类详情
      getDetalis(id) {
        API.platformDevCategory(id).then(res => {
          if (res.code == 1) {
            this.info = res.data
          }
        })
      },
      //新增设备分类
      addBtn() {
        if (!this.addForm.name || this.addForm.name.length < 1) {
          this.$message.warning("请填写正确的分类名称")
          return false;
        }
        this.addForm.parentId = this.parentId[this.parentId.length - 1]
        API.addPlatformDevCategory(this.addForm).then(res => {
          if (res.code == 1) {
            //清空数据
            this.parentId = []
            this.addForm.parentId = ''
            this.addForm.name = ''
            this.getTree()
          }
        })
      },
      delBtn(id) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          API.delplatformDevCategory(id).then(res => {
            if (res.code == 1) {
              this.$message.success('删除成功');
              this.getTree()
            } else {
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //修改设备名称
      editBtn(id) {
        API.platformDevCategory(id).then(res => {
          if (res.code == 1) {
            this.editForm = res.data
          }
        })
        this.dialogFormVisible = true
      },
      confirm() {
        let para = {
          id: this.editForm.id,
          name: this.editForm.name
        }
        let _this = this
        API.editPlatformDevCategory(this.editForm.id, para).then(res => {
          if (res.code == 1) {
            this.$message.success('修改成功')
            this.getTree()
            this.dialogFormVisible = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    mounted() {
      this.getTree()
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/equipmentGrouping.vue